import { render } from "./ContainersPage.vue?vue&type=template&id=d80aca9a"
import script from "./ContainersPage.vue?vue&type=script&lang=js"
export * from "./ContainersPage.vue?vue&type=script&lang=js"
script.render = render

export default script